const COMPONENT_RENDER_ERROR = 'COMPONENT_RENDER_ERROR';
const configReducer = (state = {}) => state;
const componentReducer = (state = {}) => state;
const componentRenderErrorReducer = (state = false, action) => {
    if (action.type === COMPONENT_RENDER_ERROR) {
        return true;
    }
    return state;
};

const latestAction = (state = '', action) => {
    return action.type;
};

const componentRenderErrorAction = (action) => {
    return {
        type: COMPONENT_RENDER_ERROR
    };
};

const actions = {
    componentRenderError: componentRenderErrorAction
};

const defaultReducers = {
    config: configReducer,
    component: componentReducer,
    latestAction,
    componentRenderError: componentRenderErrorReducer
};

export {actions};
export default defaultReducers;
